import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Component, Input } from "@angular/core";
import { NavigationService } from "navigation/navigation.service";
import { ConfigurationService } from "providers/configuration/configuration.service";
import { ReferralsServiceProvider } from "providers/patient-charts/referrals-service";
import { StateManagementService } from "providers/state-management/state-management.service";
import { Observable } from "rxjs";

@Component({
  selector: "patients-list-table",
  templateUrl: "patients-list-table.html",
})
export class PatientsListTableComponent {
  //@Input() patients: any;
  @Input() set newTeamId(newTeamId: number) {
    this.teamId = newTeamId;
    this.loadPatients();
  }

  @Input() bereavementDisciplines: boolean;

  private teamId: number;
  private idgDataUrl: string;

  private pageLimit: number = 9999;
  private currentPage: number = 0;
  private patientsFetching: boolean = true;
  private patientTotalPages: number = 1;
  private patientTotalCount: number = 0;
  private patientPages: Array<Array<any>> = [[]];
  private patients: any[] = [];
  private sortColumn: string = "lastName";
  private sortDirection: string = "ASC";
  private isPatientCalendarToggleOn: boolean = false;

  constructor(
    private configurationService: ConfigurationService,
    private http: HttpClient,
    public navSvc: NavigationService,
    public stateData: StateManagementService,
    private referralService: ReferralsServiceProvider
  ) {
    this.idgDataUrl = configurationService.resolveIdgUrl();

    this.stateData.isPatientCalendarToggleOn.subscribe((x) => {
      if (x) {
        this.isPatientCalendarToggleOn = x;
      }
    });
  }

  goToPatientProfile(chartId) {
    this.referralService.PATIENT_ID = null;
    this.referralService.CARE_TYPE = null;
    this.navSvc.goToPatientProfile(chartId);
  }

  sendtoVisitsPage(patId) {
    this.navSvc.sendtoVisitsPage(patId);
  }

  sendToPatientCalendar(patId) {
    this.navSvc.goToInternalPage("NewCalendarPage", { patChartId: patId });
  }

  sortBy(selectedCol) {
    if (this.sortColumn === selectedCol) {
      this.sortDirection = this.sortDirection === "ASC" ? "DESC" : "ASC";
    } else {
      this.sortColumn = selectedCol;
      this.sortDirection = "ASC";
    }
    this.loadPatients();
  }

  getPatientsForTeamData(teamId): Observable<any> {
    if (typeof teamId !== "undefined") {
      return new Observable((observer) => {
        try {
          let status = "On-Service,Discharged";
          if (!this.bereavementDisciplines) {
            status = "On-Service";
          }
          let headers = new HttpHeaders().set(
            "Content-Type",
            "application/json"
          );
          let params = new HttpParams()
            .set("patientStatus", status)
            .set("size", this.pageLimit.toString())
            .set("page", this.currentPage.toString())
            .set("sort", this.sortColumn)
            .set("sort", `${this.sortColumn},${this.sortDirection}`);
          if (this.sortColumn)
            this.http
              .get(
                `${this.idgDataUrl}/company-resources/userTeams/${teamId}/patients`,
                { headers: headers, params: params }
              ) // this is working to retrieve list of on-service patients for On-service list
              .subscribe(
                (response) => {
                  observer.next(response);
                  observer.complete();
                },
                (err) => {
                  observer.error(err);
                  observer.complete();
                }
              );
        } catch (error) {
          console.log("Error during data submission and building.", error);
        }
      });
    }
  }

  loadPatients = () => {
    this.patientsFetching = true;
    this.patientTotalCount = 0;
    this.patients = [];
    this.getPatientsForTeamData(this.teamId).subscribe(
      (data) => {
        this.currentPage = 0;
        this.patientTotalPages = data["totalPages"];
        this.patientTotalCount = data["totalElements"];
        this.patientPages = new Array<Array<any>>(this.patientTotalPages);
        this.patientPages[this.currentPage] = data["content"];
        this.patients = this.patientPages[0];
        this.patientsFetching = false;
      },
      (err) => {
        console.error(err);
        this.patientsFetching = false;
      }
    );
  };
}



// WEBPACK FOOTER //
// ./src/pages/common/dashboard/patients-list-table/patients-list-table.ts